module.exports = __webpack_public_path__ + "media/images/logo-white-e50b8b6649b24961b00347b9fb227875.png";